import { NumberParam, StringParam } from 'use-query-params'

import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import type { CompetitorsPricesDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'
import type { ColumnTitleSchema } from '@app/types/table'

export const columnTitleMap: ColumnTitleSchema<CompetitorsPricesDataSource> = {
  monitoringId: 'ID мониторинга',
  competitor: 'ТК конкурента',
  productCode: 'Код товара',
  howToMonitor: 'Как мониторить',
  barcodes: 'ШК товара',
  productName: 'Название товара',
  regularPrice: 'Рег.цена',
  promoPrice: 'Акц.цена',
  matchingStatus: 'Статус сопоставления',
  note: 'Примечание'
}

export const tableSearchQuerySchema: TableSearchQuerySchema<CompetitorsPricesDataSource> = {
  'table-note': StringParam,
  'table-barcodes': StringParam,
  'table-competitor': StringParam,
  'table-promoPrice': StringParam,
  'table-productCode': StringParam,
  'table-productName': StringParam,
  'table-monitoringId': NumberParam,
  'table-howToMonitor': StringParam,
  'table-regularPrice': StringParam
} as const

const titleWrapperProps = { minWidth: 200 } as const

export const columnsSearchSchema: ColumnTableSearchSchema<CompetitorsPricesDataSource> = {
  note: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  barcodes: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  competitor: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  promoPrice: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  productCode: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  productName: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  monitoringId: { type: columnSearchSchemaOptionType.NUMERIC_INPUT, titleWrapperProps },
  howToMonitor: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  regularPrice: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps }
}
